import InnerLayout from "../../../layouts/inner-layout";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useHotkeys } from "../../../helper-components/use-hotkeys";
import { useMemo, useRef, useState, useCallback, useEffect } from "react";
import { getVendorTableAction } from "../../../../redux/actions/settings-action";
import { useDispatch } from "react-redux";
// ✅ adjust import path as per your project
import DynamicTransactionTable from "../../../tables/dynamic-transaction-table";
import AddButton from "../../../buttons/button";
import errorToast from "../../../helper-components/error-toast";

const BussinessCatalouge = () => {
    const NewComponet = () => {
        const navigate = useNavigate();
        return (
            <div className="flex flex-row gap-3">
                <AddButton
                    className="flex items-center px-[12px] h-[32px] whitespace-nowrap border-radius  gap-[8px] bg-primary  cursor-pointer text-white border font-bold border-primary hover:bg-white hover:text-primary"
                    icon={"none"}
                    onclkFn={() => {
                      navigate("/settings/bussiness-catalouge/new");
                    }}
                    text={"Create Mapping"}
                />
            </div>
        );
    }
  const navigate = useNavigate();
  const dispatch=useDispatch();
  const formatDateTime = (iso) => {
  const d = new Date(iso);

  const date = d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const time = d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  return `${date}, ${time}`;
};

  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [dataCount, setDataCount] = useState(0);

  const [tableBodyData, setTableBodyData] = useState([]);


  const heading = useMemo(
    () => [
      // only Vendor Code is searchable in the filter dropdown (column: true)
      { label: "Vendor Code", value: "vendor_code", minWidth: 120,column: true,display: true,enabled: true, },
      { label: "Vendor Name", value: "vendor_name", minWidth: 160,column: false,display: true,enabled: true, },
      { label: "No.Of items", value: "no_of_items", minWidth: 120,column: false,display: true,enabled: true, },
      { label: "Created By", value: "created_by", minWidth: 140,column: false,display: true,enabled: true, },
      { label: "Created On", value: "created_on", minWidth: 170,column: false,display: true,enabled: true, },
      { label: "Updated By", value: "updated_by", minWidth: 140,column: false,display: true,enabled: true, },
      { label: "Updated On", value: "updated_on", minWidth: 170,column: false,display: true,enabled: true, }
    ],
    []
  );

  // Minimal props (DynamicTransactionTable needs these)
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  });

  // fetch with server-side vendor_code search + pagination
  const fetchData = useCallback(() => {
    setLoading(true);
    dispatch(
      getVendorTableAction(
        {
          vendor_code: filterData?.inputValue || "",
          page: currentPage,
          limit: pageSize,
        },
        (res) => {
          // tolerate both shapes: { data, total } and a plain array
          const payload = res?.data;
          const list = Array.isArray(payload) ? payload : payload?.data || [];
          const total = Array.isArray(payload)
            ? list.length
            : payload?.total ?? list.length;

          const rows = list.map((r) => ({
            id: r.cmr_id,
            vendor_code: r.vendor_code,
            vendor_name: r.vendor_name,
            no_of_items: r.no_of_items,
            cmr_id: r.cmr_id,
            created_by: r.created_by,
            updated_by: r.updated_by,
            created_on: r.created_on ? formatDateTime(r.created_on) : "-",
            updated_on: r.updated_on ? formatDateTime(r.updated_on) : "-",
          }));
          setTableBodyData(rows);
          setDataCount(total);
          setLoading(false);
        },
        () => {
          setLoading(false);
          errorToast("Failed to fetch Table data");
        }
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filterData?.inputValue, currentPage, pageSize]);

  // reset to first page whenever the search text changes
  useEffect(() => {
    setCurrentPage(1);
  }, [filterData?.inputValue]);

  useEffect(() => {
    fetchData();
  }, [fetchData, reload]);
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };


  // thunk-like dummy delete action (because DynamicTransactionTable uses dispatch(deleteAction(...)))
  const dummyVoidAction = useCallback(
    (payload, onSuccess, onError) =>
      async () => {
        try {
          setLoading(true);
          const deleteId = payload?.bc_id ?? payload?.cmr_id ?? payload?.id;
          if (deleteId) {
            setTableBodyData((prev) => prev.filter((r) => r.id !== deleteId));
          }
          setLoading(false);
          onSuccess?.({ message: "Deleted" });
        } catch (e) {
          setLoading(false);
          onError?.(e);
        }
      },
    []
  );

  return (
    <InnerLayout title="Settings" module="bussiness-catalouge-setup" list={true}>
      <div>
        <div className="flex items-center gap-2 my-2 mx-6 text-sml">
          <button
            className="flex items-center gap-2"
            onClick={() => {
              navigate("/settings");
            }}
          >
            <ChevronLeftIcon className="h-5 w-5 inline-block" />
            Data Setup Settings /
          </button>
          <span className="cursor-pointer">{" " + "Bussiness Catalouge"}</span>
        </div>
        <DynamicTransactionTable
            transaction="Business Catalogue"
            transaction_type="bussiness_catalogue"
            module={"bussiness-catalouge-setup"}
            path="bussiness-catalouge"
            tableHeading={heading}
            tableBodyData={tableBodyData}
            paginationProps={paginationProps}
            filterData={filterData}
            setFilterData={setFilterData}
            placeholder="Search (/)"
            showFilter={false}
            filterSec={true}
            filter={false}
            list={false}
            menu={true}
            is_checkbox_req={false}
            setLoading={setLoading}
            reload={reload}
            setReload={setReload}
            deleteAction={dummyVoidAction}
            transactionKey="bc"
            actionsPermissions={{
              edit: ["draft"],
              delete: ["draft"],
              send: [],
              print: [],
              clone: [],
            }}
            onClickItemFn={(id) => navigate(`/settings/bussiness-catalouge/view/${id}`)}
            onclkFn={() => console.log("new")}
            cloneFn={(id) => console.log("clone", id)}
            date={false}
            showClear={false}
            addNew={true}  
            newComponet={<NewComponet/>}
            showFilterArrows={false}
          />
      </div>
    </InnerLayout>
  );
};

export default BussinessCatalouge;
